import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from './components/Navbar';


import './css/App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from "./components/Layout";
import Head from "./components/Head";
import Doctor from "./pages/Doctor";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";



function App() {
  return (
    <BrowserRouter>
    <Head/>
      <Navbar /> 
      <Routes>
        <Route path="*" element={<Layout />} /> 
         <Route path="/About" element={<About />} /> 
          <Route path="/Services" element={<Services />} /> 
           <Route path="/Contact" element={<Contact />} /> 
            <Route path="/Gallery" element={<Gallery />} /> 

       
      </Routes>
    </BrowserRouter>
  );
}

export default App;


